module.exports = __webpack_public_path__ + "img/pet-sq.22cfae5e.svg";